import { BarChartOutlined, CreditCardOutlined, SettingFilled } from '@ant-design/icons-vue'
import { RoleGuard } from '../guards'
import { getComponent } from '../utils'
import Layout from '@/layouts/main-layout.vue'
import { h } from 'vue'
import { prefix } from '../prefix'
import type { RouteRecordRaw } from 'vue-router'

export const account_routes: RouteRecordRaw[] = [
  {
    path: '/settings',
    name: 'settings',
    component: () => getComponent(`pages/settings.vue`),
    meta: {
      title: () => 'Settings',
      layout: Layout,
      is_public: false,
      guard: RoleGuard(['org_admin', 'super_admin']),
      // menu: {
      //   // separate: true,
      //   key: 'Settings',
      //   label: 'Settings',
      //   icon: () => h(SettingFilled),
      //   path: `${prefix}/settings`,
      // },
    },
  },
  {
    path: '/usage',
    name: 'usage',
    component: () => getComponent(`pages/usage.vue`),
    meta: {
      title: () => 'Usage',
      layout: Layout,
      is_public: false,
      guard: RoleGuard(['org_admin', 'super_admin']),
      menu: {
        separate: true,
        key: 'Usage',
        label: 'Usage',
        icon: () => h(BarChartOutlined),
        path: `${prefix}/usage`,
      },
    },
  },
  {
    path: '/billing',
    name: 'billing',
    component: () => getComponent(`pages/billing.vue`),
    meta: {
      title: () => 'Billing',
      layout: Layout,
      is_public: false,
      guard: RoleGuard(['org_admin', 'super_admin']),
      menu: {
        key: 'Billing',
        label: 'Billing',
        icon: () => h(CreditCardOutlined),
        path: `${prefix}/billing`,
      },
    },
  },
]
